/* PONS prototype data. One source for formulas, doses, prices and research. */
window.PONS = {
  lines: [
    { id: "I", name: "Line I", title: "Daily foundation",
      text: "Six formulas for every day. Each one a single job, every dose on the label." },
    { id: "II", name: "Line II", title: "Situational",
      text: "Formulas for specific moments: sleep, recovery, advanced longevity. In development." },
    { id: "III", name: "Line III", title: "Targeted",
      text: "Formulas built around specific needs, developed with our scientists. In development." }
  ],

  formulas: [
    { code: "P-01", name: "Baseline", img: PONS_A+"pouch-baseline.webp?v=51b061f0", cat: "Vitamins", format: "Powder · 30 × 5 g", status: "soon",
      contents: "A, B1, B2, B3, B5, B6, biotin, folate (L-5-MTHF), B12, C, E" },
    { code: "P-02", name: "Source", cat: "Minerals", format: "Powder · 30 × 5 g", status: "soon",
      href: "/products/source", art: "source", img: PONS_A+"pouch-source.webp?v=f77cb250",
      contents: "Magnesium 250 mg, potassium 400 mg, sodium 300 mg, zinc, selenium, copper" },
    { code: "P-03", name: "Form", cat: "Creatine", format: "Powder · 30 × 5 g", status: "soon", img: PONS_A+"pouch-form.webp?v=16cab975",
      contents: "Creatine monohydrate. Full formula coming soon." },
    { code: "P-04", name: "Signal", cat: "6 ingredients · powder", format: "Powder · 30 × 5 g", status: "live",
      href: "/products/signal", img: PONS_A+"pack-light.webp?v=bde27a95",
      contents: "Citicoline, ALCAR, L-tyrosine, bacopa, L-theanine, lion's mane" },
    { code: "P-05", name: "Spark", img: PONS_A+"pouch-spark.webp?v=dab5eea8", cat: "Longevity", format: "Powder · 30 × 5 g", status: "soon",
      contents: "CoQ10 100 mg, PQQ 10 mg, alpha-lipoic acid 300 mg" },
    { code: "P-06", name: "Root", img: PONS_A+"pouch-root.webp?v=4e369ba5", cat: "Recovery", format: "Powder · 30 × 5 g", status: "soon",
      contents: "Curcumin 500 mg, ginger 200 mg, taurine, shilajit 250 mg, piperine 5 mg" }
  ],

  future: [
    { line: "II", name: "Sleep", text: "A night formula. In development." },
    { line: "II", name: "Advanced longevity", text: "In development." },
    { line: "III", name: "Tell us what you need", text: "Line III starts from your requests. Write to our scientists.", href: "/#ask" }
  ],

  signal: {
    serving: "5 g (1 scoop)",
    doses: [
      { n: "Citicoline", f: "CDP-choline", mg: 250 },
      { n: "Acetyl-L-carnitine", f: "ALCAR", mg: 500 },
      { n: "L-tyrosine", f: "Free-form amino acid", mg: 500 },
      { n: "Bacopa monnieri", f: "Extract, 20% bacosides", mg: 300 },
      { n: "L-theanine", f: "Free-form amino acid", mg: 200 },
      { n: "Lion's mane", f: "Fruiting body extract", mg: 250 },
      { n: "Inulin", f: "Carrier (chicory fibre)", mg: 2160, carrier: true }
    ],
    other: "Acidity regulator malic acid, flavouring, anti-caking agent silicon dioxide, sweetener sucralose."
  },

  source: {
    serving: "5 g (1 scoop)",
    doses: [
      { n: "Magnesium", f: "Bisglycinate 150 mg + citrate 100 mg", amt: 250, u: "mg", nrv: 67 },
      { n: "Potassium", f: "Citrate", amt: 400, u: "mg", nrv: 20 },
      { n: "Sodium", f: "Citrate", amt: 300, u: "mg", nrv: null },
      { n: "Zinc", f: "Citrate", amt: 6.5, u: "mg", nrv: 65 },
      { n: "Selenium", f: "L-selenomethionine", amt: 40, u: "µg", nrv: 73 },
      { n: "Copper", f: "Form to be confirmed", amt: 1, u: "mg", nrv: 100 }
    ],
    claims: [
      ["Magnesium", "Contributes to a reduction of tiredness and fatigue. Contributes to electrolyte balance. Contributes to normal muscle function and normal functioning of the nervous system. Contributes to normal psychological function."],
      ["Potassium", "Contributes to normal functioning of the nervous system, normal muscle function and the maintenance of normal blood pressure."],
      ["Zinc", "Contributes to normal cognitive function and to the normal function of the immune system."],
      ["Selenium", "Contributes to the normal function of the immune system and to the protection of cells from oxidative stress."],
      ["Copper", "Contributes to normal energy-yielding metabolism and to the normal function of the immune system."]
    ]
  },

  prices: {
    oneTime: 55, founding: 35, foundingCap: 100,
    ladder: [ ["Months 1–2", 49], ["Months 3–5", 47], ["Months 6–11", 44], ["Month 12+", 41] ]
  },

  /* Filled from /mnt/project-files/research/ingredient-studies.json */
  research: []
};
